import {Tool} from "../Config/Tool";
import {fmtErr, getData} from "./util";
import {observableStore} from "./obvStore";

//todo 充值
function needSelectBank(o) {
    const {support_bank_ids = '', banks = []} = o;
    return /\d+,\d+/.test(support_bank_ids) && banks.length > 1
}

const c = {
    chName: '',
    channel: {},
    loading: false,
    charge(cb) {
        const {channel, p, c, b, amount,a,ok,o:otherP,other:username} = this;
        const o = {
            amount: (parseFloat(amount.replace(/[^0-9.]/gi, '')) || 0).toFixed(2),
            bank_id: -1,
            payment_id: '',
            deposit_mode: 9,
        };
        if(otherP&&username){
            o.username=username
        }
        const unKey = ({id, vendorId}) => id + '-' + vendorId;
        if (c === -1) return '';
        const k = channel[Object.keys(channel).find(i => unKey(channel[i]) === p)];
        if (!k) return;
        const k1 = k.children.find(o => unKey(o) === c);
        if (!k1) return;
        const {
            support_bank_ids, vendorId, deposit_mode, id
        } = k1;

        if (needSelectBank(k1)) {
            const k2 = (k1.banks||[]).find(o => unKey(o) === b);
            if (!k2) return;
            o.bank_id = b.replace('-undefined', '');
            if (vendorId) o.vendorId = vendorId;
        } else {
            o.bank_id = support_bank_ids
        }
        o.deposit_mode = deposit_mode;
        o.payment_id = id;
        if(a&&ok){
            o.activity_id = a;
        }
        this.loading = true;
        getData('@/deposit/send-request', o, (data) => {
            this.loading = false;
            if ('function' === typeof cb) {
                data._t = Date.now();
                return cb(data);
            }
            Tool.alert(data.data || data.msg || '提交成功');
        }, (err) => {
            this.loading = false;
            Tool.alert(fmtErr(err,'充值失败'));
        }, 'POST')
    },
    a:'',
    ok:0,
    p: '',// lv0
    c: '',// lv1
    b: '',// lv2
    d: false,
    o: false,
    other: '',
    load() {
        this.p = this.b = this.c = -1;
        this.d = false;
        this.loading = true;
        this.channel = {};
        getData('@getChannel', undefined,
            () => {
                this.loading = false;
            }, () => {
                this.loading = false;
            })
    }
};
export const channelStore = observableStore('_ch',c);
